function ScrollTo(el) {
    var offset = jQuery('.header').outerHeight() || 0;

    document.documentElement.style.scrollBehavior = 'auto';

    jQuery('html, body').stop().animate({
        scrollTop: el.offset().top - offset
    }, {
        duration: 200,
        step: function (now, fx) {
            var newOffset = el.offset().top - offset;
            if (fx.end !== newOffset)
                fx.end = newOffset;
        },
        complete: function () {
            document.documentElement.style.scrollBehavior = 'smooth';
        }
    }, 'swing');
}

import "./modules/ToggleBodyClass";
import "./modules/Dropdown";
import "./modules/ScrollClass";
import "./modules/Tabs";
import "./modules/Accordion";
import "./modules/ContactForm"

jQuery(function ($) {

    if (typeof Fancybox !== "undefined" && $("[data-fancybox]").length) {
        Fancybox.bind('[data-fancybox]', {
            infinite: true,
            fullscreen: false,
            Toolbar: {
                display: [
                    "counter",
                    "close",
                    "zoom",
                ]
            },
            Thumbs: {
                autoStart: false
            }
        });
    }

    function initializeScrollCheck() {

        $('.table-wrapper').each(function () {
            var $this = $(this);

            function checkScrollRight() {
                var scrollLeft = $this.scrollLeft();
                var scrollWidth = $this[0].scrollWidth;
                var clientWidth = $this.outerWidth();

                if (scrollLeft + clientWidth >= scrollWidth - 10) {
                    $this.prev().addClass("done");
                } else {
                    $this.prev().removeClass("done");
                }
            }

            $this.on('scroll', function () {
                checkScrollRight();
            });

            checkScrollRight();
        });

    }

    initializeScrollCheck();

    $('.scroll, .scroll a').bind('click', function () {
        var $anchor = $(this);
        var anch = $anchor.attr('href');
        var n = anch.indexOf("#");
        var res = anch.substr(n, 999);

        ScrollTo($(res));

        return false;
    });

    $(window).resize(function () {
        initializeScrollCheck();
    });

    const $video = $('.hero__video video');
    if ($video.length) {

        const src = $video.data('src');
        const type = $video.data('type');
        if (!(src && type)) return;

        $video
            .append($('<source>', {src, type}))
            .get(0)
            .load();
    }

});